export const RESET_ERROR_BY_NAMESPACE = 'RESET_ERROR_BY_NAMESPACE';
